import * as React from 'react';
import CustomerIcon from 'lib/CustomerIcon';
import * as classnames from 'classnames';
import {
	Button,
	DataTable,
	DataTableColumn,
	DataTableRowActions,
	PageHeader
} from '@salesforce/design-system-react';
import StatusCell from 'lib/Overview/status-cell';
import ConditionalLink from 'lib/Overview/conditional-link';
import LinkCell from 'lib/Overview/link-cell';
import './overview.css';

type ColumnSpec = {
	property: string
	label: string
	link?: boolean
	handleClick?: (item: {}) => void
	conditionalLink?: string  // Name of property to show link if its true
	activeStatus?: string // For a status field, this status should turn on the green light
	statusLabels?: {[status: string]: string} // Labels to show for the different statuses
	linkStatus?: string // When the status is equal to string, a link will be rendered
};

const columnFromSpec = (spec: ColumnSpec) => {
	if (spec.link) {
		return (
			<DataTableColumn key={spec.property} label={spec.label} property={spec.property}>
				<LinkCell handleClick={spec.handleClick} />
			</DataTableColumn>
		);
	} else if (spec.conditionalLink) {
		return (
			<DataTableColumn key={spec.property} label={spec.label} property={spec.property}>
				<ConditionalLink handleClick={spec.handleClick} linkValue={spec.conditionalLink} />
			</DataTableColumn>
		);
	} else if (spec.property === 'status') {
		return (
			<DataTableColumn key={spec.property} label={spec.label} property={spec.property}>
				<StatusCell
					activeStatus={spec.activeStatus || ''}
					handleClick={spec.handleClick}
					linkStatus={spec.linkStatus || ''}
					labels={spec.statusLabels || {}}
				/>
			</DataTableColumn>
		);
	} else {
		return <DataTableColumn key={spec.property} label={spec.label} property={spec.property} />;
	}
};

interface OverviewProps extends React.HTMLAttributes<{}> {
	buttonRight?: string;
	hasGuide?: boolean;
	hasRowActions?: boolean;
	columns: ColumnSpec[];
	rows: {[prop: string]: string | number}[];
	sortedBy: string;
	title: string;
}

class Overview extends React.Component<OverviewProps> {
	columnComponents: React.ReactNode[];

	constructor (props: OverviewProps) {
		super(props);
		this.columnComponents = props.columns.map(columnFromSpec);
	}
	
	render () {
		const {buttonRight, hasGuide, hasRowActions, rows, sortedBy, title} = this.props;

		return (
			<div className={classnames('overview-table', {'has-guide': hasGuide})}>
				<PageHeader
						label="Single Customer View"
						title={title}
						info={`${rows.length} item${rows.length > 1 ? 's' : ''} • Sorted by ${sortedBy}`}
						icon={<CustomerIcon />}
						contentRight={<div style={{height: '30px'}}/>}
						navRight={buttonRight ? <span><Button label={buttonRight} /></span> : undefined}
						variant="objectHome"
				/>
				<DataTable items={rows} id="data-operations-table">
					{this.columnComponents}
					{hasRowActions ? <DataTableRowActions options={[]} /> : null}
				</DataTable>
			</div>
		);
	}
}

export default Overview;



// WEBPACK FOOTER //
// ./src/lib/Overview/index.tsx